export function removeSpecialCharacters(val) {
  return val.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export function normalizedLowerCase(val) {
  return removeSpecialCharacters(val).toLowerCase()
}
